module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12581/images/product-background.png"